import ExecutionStatus from "../../../../../types/execution-status";
import PublicStatus from "../../../../../types/public-status";

export enum OrderCargoOrderFinishedDownloadParamsSortKey {
  ORDER_START_DATE_ASC = "ORDER_START_DATE_ASC",
  ORDER_START_DATE_DESC = "ORDER_START_DATE_DESC",
  INTERNAL_ORDER_ID_ASC = "INTERNAL_ORDER_ID_ASC",
  INTERNAL_ORDER_ID_DESC = "INTERNAL_ORDER_ID_DESC",
}

type OrderCargoOrderFinishedDownloadParams = {
  internalOrderId?: number;
  isUrgent?: boolean;
  client?: string;
  dispatch?: string;
  driver?: string;
  externalOrderId?: string;
  address?: string;
  pickupAddress?: string;
  intermediateAddress?: string;
  destinationAddress?: string;
  taxi?: string;
  passenger?: string;
  executionStatus?: ExecutionStatus;
  publicStatus?: PublicStatus;
  sortKey?: OrderCargoOrderFinishedDownloadParamsSortKey;
  orderStartDateTo?: Date;
  orderStartDateFrom?: Date;
};

export default OrderCargoOrderFinishedDownloadParams;
